import { Spinner, HStack } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuthenticationStore } from '$/components/core/Authentication/stores/useAuthenticationStore';
import { useToast } from '$/hooks/useToast';
import { OidcCallbackRoute } from '$/routes/OidcRoutes';
import { signInViaOidcToken } from '$/services/usecases/authentication';

export const OidcCallbackPage = () => {
  const { code } = OidcCallbackRoute.useSearch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const authenticate = useAuthenticationStore((state) => state.authenticate);
  const toast = useToast();
  const mutex = useRef(false);

  const getToken = useMutation({
    mutationFn: async (code: string) => {
      const result = await signInViaOidcToken({ code });
      if (!result.isSuccessful) {
        throw new Error(result.response.message);
      }
      return result.response;
    },
    onSuccess: (data) => {
      if (data.user && data.accessToken) {
        authenticate(data.user, data.accessToken);
      }
      navigate({ to: '/' });
    },
    onError: () => {
      toast(
        t('error.somethingWentWrong'),
        'error',
        t('error.somethingWentWrongDescription'),
      );

      navigate({ to: '/' });
    },
  });

  useEffect(() => {
    if (code && !mutex.current) {
      mutex.current = true;
      void getToken.mutate(code);
    } else if (!code) {
      navigate({ to: '/' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  return (
    <HStack alignItems='center' justifyContent='center' w='full' h='full'>
      <Spinner size='xl' />
    </HStack>
  );
};
